import { Button, Space, Tag } from 'antd';
import { StoryFramesModel } from 'interface/models';
import { LoadingOutlined } from '@ant-design/icons';
import { LazyVideoPlayer } from './LazyVideoPlayer';

interface StoryFrameProps {
  frame: StoryFramesModel;
  storyId: number;
  displayType?: 'text' | 'image' | string;

  onChange: (frame: StoryFramesModel) => void;
  onReload: () => void;
}

export const TimelinePlan_Frame = (props: StoryFrameProps) => {
  const frame = props.frame;

  if (['hidden', 'skip'].includes(frame.status)) {
    return (
      <>
        {frame.initText.slice(0, 100)}...
        <br />
        <br />
      </>
    );
  }

  return (
    <>
      {(frame.videos || []).map((video, index) => (
        <LazyVideoPlayer displayType={props.displayType} key={`${frame.id}-${index}`} videoSrc={video} frame={frame} index={index} />
      ))}
    </>
  );
};
